import { getExpiryTime } from "./tokenHandler";
import { immediateToast } from "izitoast-react";
import { Session_Expired } from "./errorMessage";
import NavigationBar from "../../Pages/NavigationBar/NavigationBar";
import Message from "../../Container/Message/Message";

export const hasSessionExpired = () => {
  let sessionExpire = new Date(getExpiryTime());
  let today = new Date();

  if (window) {
    window.removeEventListener(
      "click",
      NavigationBar.handleClickOutside,
      false
    );
    window.removeEventListener("resize", Message.setNewSize, false);
  }

  if (today.getTime() >= sessionExpire.getTime()) {
    immediateToast("warning", {
      message: Session_Expired,
    });
    localStorage.clear();
    window.location.href = "/";
  }
};
